<!-- <div
  class="element-container p-6 bg-white border border-slate-200 rounded-xl shadow-sm max-w-2xl font-sans m-auto"
> -->
<div
  class="element-container p-6 bg-white border border-slate-200 rounded-xl shadow-sm m-auto font-sans w-fit min-w-full md:min-w-2xl"
>
  <div class="mb-6">
    <div class="flex justify-between items-center mb-2">
      <span class="ml-auto text-xs font-semibold inline-block text-blue-600">
        {{ page()?.progress }}%
      </span>
    </div>
    <div class="overflow-hidden h-2 text-xs flex rounded bg-slate-100">
      <div
        [style.width.%]="page()?.progress"
        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500 transition-all duration-500"
      ></div>
    </div>
  </div>

  @for (item of page()?.elements; track item.id) {
  <lib-element [element]="item" [id]="item.id"></lib-element>
  }

  <div class="flex justify-end mt-4 pt-4 border-t border-slate-100">
    @if(page()?.navigation?.showBackwardButton) {
    <button
      (click)="goBack()"
      class="flex items-center justify-center p-2 rounded-full text-slate-500 hover:bg-slate-100 transition-colors duration-200 focus:outline-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.75 19.5L8.25 12l7.5-7.5"
        />
      </svg>
    </button>
    } @else {
    <div></div>
    } @if(page()?.navigation?.showForwardButton) {
    <button
      (click)="goForward()"
      [disabled]="!isValid()"
      class="flex items-center justify-center p-2 rounded-full text-slate-500 hover:bg-slate-100 transition-colors duration-200 focus:outline-none"
    >
      <span class="mr-1 font-medium">Next</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.25 4.5l7.5 7.5-7.5 7.5"
        />
      </svg>
    </button>
    }
    <button
      type="button"
      (click)="goForward()"
      class="inline-flex items-center px-5 py-2.5 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200 shadow-sm focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="!isValid()"
    >
      Next
    </button>
  </div>
</div>

<!-- web-survey-preview -->
<!-- <div class="fixed bottom-0 left-0 right-0 z-50 p-6 pointer-events-none">
  <div class="max-w-2xl mx-auto pointer-events-auto">
    <div
      class="bg-white/90 backdrop-blur-md border border-slate-200 shadow-xl rounded-2xl px-6 py-3 flex items-center justify-between gap-6"
    >
      <div class="flex items-center gap-3 shrink-0">
        <div class="bg-blue-50 p-2 rounded-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </div>
        <div>
          <h3 class="text-slate-700 text-xs font-bold leading-none">
            Web Survey Preview
          </h3>
          <p class="text-[10px] text-slate-400 font-medium mt-1">
            Preview Mode
          </p>
        </div>
      </div>

      <div class="relative w-full max-w-[240px]">
        <select
          (change)="onJump($event)"
          class="w-full bg-slate-50 text-slate-700 text-sm rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 py-2.5 pl-4 pr-10 cursor-pointer outline-none appearance-none transition-all hover:bg-slate-100"
        >
          <option value="" disabled selected>Jump to question...</option>
          @for (el of page()?.elements; track el.id) {
          <option [value]="el.id">
            Q{{ $index + 1 }}: {{ el.name || 'Untitled' }}
          </option>
          }
        </select>

        <div
          class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-slate-400"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="3"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div> -->
